import Vue from 'vue'

const sanitize = (obj) => {
  return JSON.parse(
    JSON.stringify(obj, (key, value) => {
      if (typeof value === 'function') return '[Function]'
      if (value instanceof HTMLElement) return '[HTMLElement]'
      if (value && value._isVue) return '[VueInstance]'
      return value
    })
  )
}

export default ({ app }) => {
  const originalErrorHandler = Vue.config.errorHandler

  Vue.config.errorHandler = (err, vm, info) => {
    const componentName = vm?.$options?.name || vm?.$options?._componentTag || vm?.$vnode?.tag || 'anonymous'

    const context = {
      component: componentName,
      props: vm?.$options?.propsData ? sanitize(vm.$options.propsData) : undefined,
      data: vm?.$data ? sanitize(vm.$data) : undefined,
      info,
    }

    // Send error to DataDog
    if (app.$ddRum) {
      app.$ddRum.addError(err, context)

      // Mark an error with [SKIP_DD] to skip double logging when it bubbles up in originalErrorHandler
      if (!err?.message?.includes?.('[SKIP_DD]')) {
        err.message += ' [SKIP_DD]'
      }
    }

    // Call the original error handler to preserve default behavior and let other error handlers like Sentry to process it
    if (originalErrorHandler) {
      originalErrorHandler(err, vm, info)
    }
  }
}
